import CustomDialog from "components/Dialogs/MasterDialog";
import CenterForm from "./CenterForm";
import { centersTexts } from "locale/es";
import { useNavigate } from "react-router-dom";
import { createCenter } from "redux/reducers/centersReducer";
import { useSelector } from "react-redux";

export function DisplayNewCenterForm() {
  const navigate = useNavigate()

  const centers = useSelector(({ centers }) => centers)?.data

  function handleShowAddModal() {
    navigate('/gestio-dels-centres');
  }

  return (
    <CustomDialog
      title={centersTexts.CREATED_TITLE}
      show={true}
      handleShow={handleShowAddModal}
    >
      <CenterForm
        handleShow={handleShowAddModal}
        onSubmit={createCenter}
        centers={centers}
      />
    </CustomDialog>

  )
}